import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem, TextField, Box } from '@mui/material';

const ValueSelector = ({ options, fieldName, onValueChange, mandatory }) => {
    const [selectedValue, setSelectedValue] = useState('');
    const [manualInput, setManualInput] = useState('');

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
        if (value === 'custom') {
            setManualInput(''); // Clear manual input when selecting custom
        } else {
            setManualInput(''); // Clear manual input when selecting an existing value
        }
        onValueChange(value === 'custom' ? manualInput : value); // Notify parent of the change
    };

    const handleInputChange = (event) => {
        setManualInput(event.target.value);
    };

    const handleInputBlur = () => {
        // Notify parent of the custom input when the input loses focus
        if (manualInput) {
            onValueChange(manualInput); // Notify parent of the custom input
        }
    };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <FormControl sx={{ minWidth: 300 }} variant="outlined" margin="normal">
                <InputLabel id={`${fieldName}-select-label`}>{fieldName}</InputLabel>
                <Select
                    labelId={`${fieldName}-select-label`}
                    value={selectedValue}
                    onChange={handleSelectChange}
                    label={fieldName}
                >
                    {options.map((value, index) => (
                        <MenuItem key={index} value={value}>
                            {value}
                        </MenuItem>
                    ))}
                    <MenuItem value="custom">Other</MenuItem>
                </Select>
            </FormControl>
            {selectedValue === 'custom' && (
                <TextField
                    required={mandatory}
                    label={`Enter custom ${fieldName.toLowerCase()}`}
                    variant="outlined"
                    value={manualInput}
                    onChange={handleInputChange}
                    onBlur={handleInputBlur} // Set value on blur
                    placeholder={`Enter custom ${fieldName.toLowerCase()}`}
                    style={{ width: "300px" }}
                />
            )}
        </Box>
    );
};

export default ValueSelector;
